var _path, _g, _path2, _path3, _g2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 16,
    viewBox: "0 0 68 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5830_438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0376 0.0119629H33.0486V15.9463H17.0376V0.0119629Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5830_438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0431 3.86608C22.7399 3.86608 21.0682 5.59559 21.0682 7.9791C21.0682 10.3627 22.7399 12.0922 25.0431 12.0922C27.3463 12.0922 29.0175 10.3627 29.0175 7.9791C29.0175 5.59559 27.3463 3.86608 25.0431 3.86608ZM25.0431 15.9464C20.5543 15.9464 17.0376 12.4467 17.0376 7.9791C17.0376 3.51156 20.5543 0.0119629 25.0431 0.0119629C29.532 0.0119629 33.0486 3.51156 33.0486 7.9791C33.0486 12.4467 29.532 15.9464 25.0431 15.9464Z",
    fill: "#CCD4D8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7872 16C42.6851 16 42.6064 15.9977 42.5547 15.9963C38.1875 15.8898 34.9266 12.3781 34.9444 7.8266C34.9618 3.43782 38.427 0 42.8321 0C44.1467 0.00556911 46.6091 0.388108 48.8673 2.8582L45.5711 4.77413C44.9163 4.14434 43.8651 3.73855 42.8591 3.73433C41.4535 3.73433 38.8207 4.61847 38.8075 7.96513C38.8029 9.10533 39.2108 10.1721 39.9562 10.9688C40.7113 11.7762 41.7392 12.2229 42.8505 12.2275C43.9131 12.2275 44.8101 11.8933 45.4635 11.2607C45.5972 11.1315 45.6256 10.9354 45.5377 10.7489L43.9521 7.56447L48.4382 7.58307L50.0357 10.7922C50.0591 10.8387 50.0618 10.8926 50.0431 10.9409C48.3174 15.5068 44.3944 16 42.7872 16Z",
    fill: "#CCD4D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5830_438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 0,
    width: 17,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.989 0.0119629H68V15.9463H51.989V0.0119629Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5830_438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9945 3.86608C57.6913 3.86608 56.0197 5.59559 56.0197 7.9791C56.0197 10.3627 57.6913 12.0922 59.9945 12.0922C62.2977 12.0922 63.9694 10.3627 63.9694 7.9791C63.9694 5.59559 62.2977 3.86608 59.9945 3.86608ZM59.9945 15.9464C55.5057 15.9464 51.989 12.4467 51.989 7.9791C51.989 3.51156 55.5057 0.0119629 59.9945 0.0119629C64.4834 0.0119629 68 3.51156 68 7.9791C68 12.4467 64.4834 15.9464 59.9945 15.9464Z",
    fill: "#CCD4D8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96495 15.0588L0 0H4.98192L8.97247 7.27605L12.9625 0H17.9444L8.97949 15.0588H8.96495Z",
    fill: "#CCD4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11);
export default __webpack_public_path__ + "static/media/Group_11.8b1e19d229e96176fe4e344204c19c61.svg";
export { ForwardRef as ReactComponent };